import {
  UseAdSpend,
  UseAdSpendOptions,
  useAdSpend as useAdSpendShared,
} from '../../../hooks/useAdSpend';
import { useCampaign, useCampaignParameters } from './useCampaign';
import { useCurrentChannel } from '../../../hooks/useCurrentChannel';

export const useAdSpend = (
  options: Pick<UseAdSpendOptions, 'campaignId'>
): UseAdSpend => {
  const { campaignId } = options;
  const { channel: partner } = useCurrentChannel();
  const { campaign } = useCampaign({ id: campaignId });

  return useAdSpendShared({
    campaignId,
    overallAdSpend: campaign?.adSpend ?? null,
    partner,
  });
};

export const useCurrentAdSpend = (): UseAdSpend => {
  const { id } = useCampaignParameters();
  return useAdSpend({ campaignId: Number(id) });
};
